import { render } from "./ProjectsPage.vue?vue&type=template&id=50087148"
import script from "./ProjectsPage.vue?vue&type=script&lang=js"
export * from "./ProjectsPage.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ProjectsPage.vue?vue&type=style&index=0&id=50087148&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__